import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getAccountingAccess(token) {
  const res = await axios.get(`${API}/accounting/access`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingProfile(token) {
  const res = await axios.get(`${API}/accounting/profile`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAccountingChecklist(token) {
  const res = await axios.get(`${API}/accounting/checklist`, {
    headers: authHeaders(token),
  });
  return res.data;
}
